import { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'antd';
import type { TooltipProps } from 'antd';

/**
 * Tooltip tuned for hint text: it only appears after a 1s hover (so it doesn't
 * flash on every pass) and auto-hides 5s after showing (so it never lingers over
 * the content). Drop-in for antd's <Tooltip>; callers may still override
 * mouseEnterDelay. Controlled `open` is derived internally, so any explicit
 * open/onOpenChange passed in is intentionally ignored.
 */
export function HintTooltip({ mouseEnterDelay, ...props }: TooltipProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timer.current), []);

  const handleOpenChange = (next: boolean): void => {
    clearTimeout(timer.current);
    setOpen(next);
    if (next) {
      timer.current = setTimeout(() => setOpen(false), 5000);
    }
  };

  return (
    <Tooltip
      {...props}
      mouseEnterDelay={mouseEnterDelay ?? 1}
      open={open}
      onOpenChange={handleOpenChange}
    />
  );
}
